import React from 'react';
import ModalEditTeamDiff from '../../../company/profil/pitch/modal/modal-team-differenciator';
import { IProps } from '../../../company/profil/pitch/modal/modal-team-differenciator';
export default function ModalFundingRound(props: IProps) {
  return <ModalEditTeamDiff {...props} />;
}
